export default "assets/images/icons/cepage-d6b463bd.svg";